import React, { useEffect, useState } from "react";
import Brands from "../../common/Brands/Brands";
import FooterThree from "../../common/Footer/FooterThree";
import Menu from "../../common/Menu/Menu";
import Testimonial from "../../common/Testimonial/Testimonial";
import Services from "../../HomeTwo/Services";
import AboutBanner from "./AboutBanner";
import AboutCompany from "./AboutCompany";
import AboutFeature from "./AboutFeature";
import ElevatorLoader from "../../Loder/ElevatorLoader";

const About = () => {
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 576);
    };

    checkScreenSize(); // run on mount
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);
  return (
    <div>
      {loading && <ElevatorLoader onFinish={() => setLoading(false)} />}
      <Menu header_style_2={true} />
      <AboutBanner />
      <AboutCompany />
      <Services />
      <AboutFeature />
      <div style={{ marginTop: isMobile ? 0 : "10px" }}>
        <Testimonial />
      </div>
      
      {/* <Brands /> */}
      <FooterThree />
  </div>
  );
};

export default About;
